// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"left-content_wrapper__2UK-d","firstTitle":"left-content_firstTitle__39QXS","secondTitle":"left-content_secondTitle__ucNlj"};